import { render, staticRenderFns } from "./EditStockItem.vue?vue&type=template&id=4b31c90a"
import script from "./EditStockItem.vue?vue&type=script&lang=js"
export * from "./EditStockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditStockItem.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b31c90a')) {
      api.createRecord('4b31c90a', component.options)
    } else {
      api.reload('4b31c90a', component.options)
    }
    module.hot.accept("./EditStockItem.vue?vue&type=template&id=4b31c90a", function () {
      api.rerender('4b31c90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditStockItem.vue"
export default component.exports